import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { fetchLevelTestSummaryAPI } from "../levelTestAPI";
import { readSessionFromUrl } from "../session";
import "./ReviewList.css";
import { rowOrderOf } from "../rowOrder";

// 레벨테스트 복습을 과제 목록에 얹는다. 복습은 ECHO 계통이라 우리 과제(Assignment)와
// 모양이 다르다. 알림장이 그렇듯 별도 계통으로 두고 목록에서만 합쳐 보여준다.
//
// 카드 모양은 미완료 과제 카드와 **같은 값**으로 맞춘다. 한 목록 안에서 두 계통이
// 다르게 생기면 학생 눈에는 그냥 깨진 화면으로 보인다.
//
// variant="unfinished" 는 해야 할 복습, "finished" 는 끝낸 복습이다.
const KIND_TAG_STYLE = {
  vocab: { bg: "#E5FBF8", color: "#00A396" },
  listen: { bg: "#EEF0FB", color: "#5A6BD8" },
  grammar: { bg: "#FBF6EC", color: "#B4771E" },
  reading: { bg: "#E8F7EE", color: "#158A48" },
};

const formatDate = (value) => {
  if (!value) {
    return "-";
  }
  const date = new Date(value);
  return `${date.getMonth() + 1}.${date.getDate()}`;
};

const ReviewList = ({ variant }) => {
  const [items, setItems] = useState([]);
  const { mode } = useSelector((state) => state.ui);
  const isMobile = mode === "mobile";

  useEffect(() => {
    const identity = readSessionFromUrl();
    if (!identity) {
      return undefined;
    }

    let isCurrent = true;
    fetchLevelTestSummaryAPI(identity.studentId, identity.randomCode)
      .then((data) => {
        if (!isCurrent) {
          return;
        }
        setItems(
          (variant === "finished"
            ? data.finished_reviews
            : data.unfinished_reviews) || []
        );
      })
      .catch(() => {
        // 레벨테스트를 안 쓰는 학원도 있다. 못 불러오면 아무것도 그리지 않는다.
      });

    return () => {
      isCurrent = false;
    };
  }, [variant]);

  if (!items.length) {
    return null;
  }

  // 감싸는 칸을 두지 않는다. 과제 줄과 형제로 놓여야 날짜순으로 자리를 잡는다.
  return (
    <>
      {items.map((item) => {
        const tagStyle = KIND_TAG_STYLE[item.kind] || KIND_TAG_STYLE.vocab;

        return (
          <a
            key={item.key}
            href={variant === "finished" ? item.result_url : item.start_url}
            target="_blank"
            rel="noreferrer"
            className="review-card"
            style={{
              order: rowOrderOf(item.due_at || item.opens_at),
              backgroundColor: "#FFF",
              border: "1px solid #E6EDEC",
              borderRadius: "16px",
              padding: isMobile ? "12px 14px" : "15px 18px",
              display: "flex",
              alignItems: "center",
              gap: isMobile ? "10px" : "14px",
              boxShadow: "0 10px 30px -24px rgba(20,40,50,.2)",
              flexWrap: "nowrap",
            }}
          >
            {!isMobile && (
              <div style={{ flex: "0 0 auto", width: "96px", lineHeight: 1.5 }}>
                <div style={{ fontSize: "0.8rem", color: "#7A8490", fontWeight: 600 }}>
                  레벨테스트
                </div>
                <div style={{ fontSize: "0.8rem", color: "#3A434E", fontWeight: 700 }}>
                  <em
                    style={{
                      fontStyle: "normal",
                      fontSize: "0.7rem",
                      color: "#B9C1C9",
                      fontWeight: 700,
                      marginRight: "4px",
                    }}
                  >
                    마감
                  </em>
                  {formatDate(item.due_at)}
                </div>
              </div>
            )}

            <div
              style={{
                flex: 1,
                minWidth: 0,
                display: "flex",
                alignItems: "center",
                gap: "7px",
                flexWrap: "nowrap",
                overflow: "hidden",
              }}
            >
              <span
                style={{
                  fontWeight: 700,
                  fontSize: isMobile ? "0.88rem" : "0.95rem",
                  color: "#0E141B",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  minWidth: 0,
                }}
              >
                {item.title}
              </span>
              <span
                style={{
                  fontSize: "0.73rem",
                  fontWeight: 700,
                  padding: "3px 10px",
                  borderRadius: "999px",
                  backgroundColor: tagStyle.bg,
                  color: tagStyle.color,
                  flex: "0 0 auto",
                  whiteSpace: "nowrap",
                }}
              >
                {item.kind_label}
              </span>
            </div>

            {variant !== "finished" && item.is_overdue && (
              <span
                style={{
                  fontSize: "0.76rem",
                  fontWeight: 800,
                  padding: "4px 11px",
                  borderRadius: "999px",
                  backgroundColor: "#FDF0F0",
                  color: "#D64545",
                  flex: "0 0 auto",
                }}
              >
                기한 지남
              </span>
            )}

            <span
              style={{
                flex: "0 0 auto",
                fontWeight: 800,
                fontSize: "0.88rem",
                color: "#00A396",
                whiteSpace: "nowrap",
              }}
            >
              {variant === "finished" ? "결과 보기 ›" : "복습하기 ›"}
            </span>
          </a>
        );
      })}
    </>
  );
};

export default ReviewList;
